import { getVideoURLBasedOnEvent } from "constants/media";
import { Dot } from "lucide-react";

export function truncateText(text, maxLength = 20) {
  if (text?.length <= maxLength) return text;
  return text?.slice(0, maxLength) + "...";
}

const YouTubePostPreview = ({ selectedEvent, title }) => {
  const videoUrl = getVideoURLBasedOnEvent(selectedEvent);

  return (
    <div className="w-full h-full bg-[white] border rounded-[1vh] shadow-sm p-[2vh] mt-[2vh] max-h-[100vh]">
      {/* Video */}
      <div className="mt-[2vh]">
        <video
          src={videoUrl}
          className="w-full h-[36vh] object-contain rounded-[1vh]"
          controls
          muted
          autoPlay
          loop
        />
      </div>

      {/* User Info + Options */}
      <div className="flex items-center justify-between my-[2vh]">
        <div className="flex items-center gap-[1.5vh]">
          <div className="w-[4vh] h-[4vh] bg-red-200 rounded-full flex items-center justify-center text-red-500 font-bold text-[2vh]">
            S
          </div>
          <div className="text-[1.8vh] text-gray-800">
            {truncateText(title, 30)}
          </div>
        </div>
        <button className="text-[3vh] text-gray-500 hover:text-gray-800">
          ⋮
        </button>
      </div>

      {/* Channel + Stats */}
      <div className="font-semibold text-gray-900 text-[2vh]">soomuch.ai</div>
      <div className="text-[1.5vh] text-gray-500 mt-[1vh]">
        <span>55k Views</span>
        <Dot className="inline-block text-gray-500 w-[1.6vh] h-[1.6vh]" />
        <span>2 hours ago</span>
      </div>
    </div>
  );
};

export default YouTubePostPreview;
